import { ciBold } from '~/icons/source/solid/bold'
import { ciItalic } from '~/icons/source/solid/italic'
import { ciUnderline } from '~/icons/source/solid/underline'
import { ciHeading1 } from '~/icons/source/solid/heading-1'
import { ciHeading2 } from '~/icons/source/solid/heading-2'
import { ciHeading3 } from '~/icons/source/solid/heading-3'
import { ciListOrdered } from '~/icons/source/solid/list-ordered'
import { ciAlignLeft } from '~/icons/source/solid/align-left'
import { ciAlignCenter } from '~/icons/source/solid/align-center'
import { ciAlignRight } from '~/icons/source/solid/align-right'
import { ciUndo } from '~/icons/source/solid/undo'
import { ciImage } from '~/icons/source/solid/image'
import { ciRedo } from '~/icons/source/solid/redo'
import { ciList } from '~/icons/source/solid/list'
import { ciLink } from '~/icons/source/solid/link'

export const extensionsConfiguration = {
  bold: {
    inMenu: true,
    commands: [{ actionName: 'toggleBold', namespace: 'bold', icon: ciBold }]
  },
  heading: {
    inMenu: true,
    commands: [
      {
        actionName: 'toggleHeading',
        namespace: 'heading',
        icon: ciHeading1,
        options: { level: 1 }
      },
      {
        actionName: 'toggleHeading',
        namespace: 'heading',
        icon: ciHeading2,
        options: { level: 2 }
      },
      {
        actionName: 'toggleHeading',
        namespace: 'heading',
        icon: ciHeading3,
        options: { level: 3 }
      }
    ]
  },
  bulletList: {
    inMenu: true,
    commands: [
      {
        actionName: 'toggleBulletList',
        namespace: 'bulletList',
        icon: ciList
      }
    ]
  },
  orderedList: {
    inMenu: true,
    commands: [
      {
        actionName: 'toggleOrderedList',
        namespace: 'orderedList',
        icon: ciListOrdered
      }
    ]
  },
  listItem: {
    inMenu: false
  },
  underline: {
    inMenu: true,
    commands: [
      {
        actionName: 'toggleUnderline',
        namespace: 'underline',
        icon: ciUnderline
      }
    ]
  },
  italic: {
    inMenu: true,
    commands: [
      {
        actionName: 'toggleItalic',
        namespace: 'italic',
        icon: ciItalic
      }
    ]
  },
  placeholder: {
    inMenu: false
  },
  history: {
    inMenu: true,
    commands: [
      { actionName: 'undo', namespace: 'history', icon: ciUndo },
      { actionName: 'redo', namespace: 'history', icon: ciRedo }
    ]
  },
  image: {
    HTMLAttributes: {
      class: 'tw-block'
    },
    inMenu: true,
    commands: [
      {
        actionName: 'setImage',
        namespace: 'image',
        icon: ciImage
      }
    ]
  },
  link: {
    inMenu: true,
    commands: [
      {
        actionName: 'toggleLink',
        namespace: 'link',
        icon: ciLink
      }
    ]
  },
  textAlign: {
    inMenu: true,
    commands: [
      {
        actionName: 'setTextAlign',
        namespace: 'textAlign',
        icon: ciAlignLeft,
        options: 'left'
      },
      {
        actionName: 'setTextAlign',
        namespace: 'textAlign',
        icon: ciAlignCenter,
        options: 'center'
      },
      {
        actionName: 'setTextAlign',
        namespace: 'textAlign',
        icon: ciAlignRight,
        options: 'right'
      }
    ]
  }
}
